import(/* webpackMode: "eager", webpackExports: ["ThreeWayComparison"] */ "/vercel/path0/frontend/app/compare/opus-clip-vs-vizard/ThreeWayComparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/frontend/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/frontend/node_modules/next/dist/client/app-dir/link.js");
